<template>
    <b-list-group-item>{{ model.functionName }} <b-badge pill variant="warning" class="float-right home-inbox-counter">{{ model.totalInbox }}</b-badge></b-list-group-item>
</template>
<script>
export default {
    props :
    {
        model : {
            default: {},
            type: Object
        }
    }
}
</script>